import { create } from 'zustand';

type SignInDialogView =
    'sign-in' | 'oauth-account' | 'account' | 'feature-flags';

/** The account windows the feature-flags view is reached from. */
type FeatureFlagsOrigin = 'oauth-account' | 'account';

interface SignInDialogState {
    isOpen: boolean;
    view: SignInDialogView;
    /** Where the feature-flags view's back action returns to. */
    featureFlagsOrigin: FeatureFlagsOrigin;
    open: () => void;
    openOAuthAccount: () => void;
    /**
     * The account window for an identity that is NOT social-primary: what a
     * wallet-first user reaches from their identity button. Passkey management
     * lives here, next to the option of adding a social login to the account
     * they already own.
     */
    openAccount: () => void;
    /** [Manage feature flags] from either account window. */
    openFeatureFlags: () => void;
    /** Back from the feature-flags view to the window it was opened from. */
    backFromFeatureFlags: () => void;
    close: () => void;
}

export const useSignInDialogStore = create<SignInDialogState>((set) => ({
    isOpen: false,
    view: 'sign-in',
    featureFlagsOrigin: 'oauth-account',
    open: () => set({ isOpen: true, view: 'sign-in' }),
    openOAuthAccount: () => set({ isOpen: true, view: 'oauth-account' }),
    openAccount: () => set({ isOpen: true, view: 'account' }),
    openFeatureFlags: () =>
        set((state) => ({
            isOpen: true,
            view: 'feature-flags',
            featureFlagsOrigin:
                state.view === 'account' ? 'account' : 'oauth-account',
        })),
    backFromFeatureFlags: () =>
        set((state) => ({ view: state.featureFlagsOrigin })),
    close: () => set({ isOpen: false }),
}));
